import {
  BaseUserProfile,
  IMarketingAnalyticsProvider,
  MarketingAnalyticsEvents,
} from 'fitbeat.models';

export class MarketingAnalyticsService {
  constructor(
    private readonly analyticsProviders: IMarketingAnalyticsProvider[],
    private logger: any,
  ) {}

  public logEventInBackground(
    name: MarketingAnalyticsEvents,
    userProfile: BaseUserProfile,
    data?: any,
  ) {
    this.logEvent(name, userProfile, data)
      .catch((e) => this.logger.error('failed to logEvents', e));
  }

  public async logEvent(
    name: MarketingAnalyticsEvents,
    userProfile: BaseUserProfile,
    data?: any) {
    for (const provider of this.analyticsProviders) {
      try {
        await provider.logEvent(name, userProfile, data);
      } catch (e: any) {
        this.logger.error(`Analytics provider ${provider.name} failed with error ${e}`);
      }
    }
  }

  public syncCustomerToProvidersInBackground(userProfile: BaseUserProfile) {
    this.syncCustomerToProviders(userProfile)
      .catch((e) => this.logger.error('failed to syncCustomerToProviders', e));
  }

  public async syncCustomerToProviders(
    userProfile: BaseUserProfile) {
    for (const provider of this.analyticsProviders) {
      try {
        await provider.syncCustomer(userProfile);
      } catch (e: any) {
        this.logger.error(`Analytics provider ${provider.name} failed with error ${e}`);
      }
    }
  }
}
